import React from 'react';
import PropTypes from 'prop-types';
import { actionsMap } from '@constants/logs';
import CustomTooltip from '@shared/custom-tooltip';
import './icon.scss';

const Icon = ({ action, attrs, type }) => {
  const getActionTemplate = () => actionsMap[action];

  const getTooltip = () => {
    const template = getActionTemplate();
    const { tooltip } = template;
    if (typeof tooltip === 'string') {
      return tooltip;
    }
    return tooltip(type, attrs);
  };

  const getIcon = () => {
    const template = getActionTemplate();
    const { icon } = template;
    if (typeof icon === 'object') {
      return icon;
    }
    return icon(attrs);
  };

  const tooltip = getTooltip();

  return (
    <CustomTooltip title={tooltip} placement="bottom-start">
      <div styleName="activity-logs-icon">
        {/* The icon conveys real, non-redundant meaning (e.g. "Current project manager")
            that isn't otherwise in the row's visible text - a visually-hidden span carries
            it to screen readers, since a generic <div>'s aria-label (from the Tooltip above)
            is ignored: role="generic" doesn't support an accessible name. */}
        {tooltip && <span styleName="visually-hidden">{tooltip}</span>}
        <span aria-hidden="true">{getIcon()}</span>
      </div>
    </CustomTooltip>
  );
};

Icon.propTypes = {
  action: PropTypes.string,
  attrs: PropTypes.object,
  type: PropTypes.string
};

export default Icon;
